/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipForwardIcon20Light = forwardRef('MediaUiASkipForwardIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3.5a.5.5 0 0 0-1 0v6.038a1.286 1.286 0 0 0-.507-.627L5.7 3.185a1.1 1.1 0 0 0-1.7.922v11.786a1.1 1.1 0 0 0 1.7.922l8.793-5.726c.246-.16.415-.381.507-.627V16.5a.5.5 0 0 0 1 0v-13ZM5 4.107a.1.1 0 0 1 .155-.084l8.793 5.726a.3.3 0 0 1 0 .502l-8.793 5.726A.1.1 0 0 1 5 15.893V4.107Z" })));
});
